import { createRoute, createRouter, redirect } from '@tanstack/react-router'

import { createErrorRoute } from '@authy/lib-web/routes'
import { createGlobalInstance } from '@authy/lib-client/utils/state'

import { appRoute } from './app'
import { userRoute } from './user'
import { tenantRoute } from './tenant'
import { invitationRoute } from './invitation'

export const router = createGlobalInstance('router', () => {
    const defaultRoute = createRoute({
        getParentRoute: () => appRoute,
        path: '/',
        beforeLoad: async ({ location }): Promise<void> => {
            if (!location.pathname.split('/')[1]) {
                throw redirect({
                    replace: true,
                    to: '/user',
                })
            }
        },
    })

    // Create the route tree using your routes
    const routeTree = appRoute.addChildren([
        defaultRoute,
        invitationRoute,
        userRoute,
        tenantRoute,
        createErrorRoute(appRoute),
    ])

    // Create the router using your route tree
    return createRouter({ routeTree, defaultGcTime: 0 })
})

// Register your router for maximum type safety
declare module '@tanstack/react-router' {
    /* eslint-disable @typescript-eslint/consistent-type-definitions */
    interface Register {
        router: typeof router
    }
}
